import React from 'react';
import StatGrid from '../../StatGrid';
import { coreSync } from '../../../lib/core';
import { attendanceBillingLabel } from '../../../domain/lessonAttendance';
import Unread from '../../Unread';
import { READING_WORDING as RW, figureOrDash } from '../../../domain/reading';
import { useDateFormat, useTimeFormat } from '../../../context/LocaleContext';
import s from './tabs.module.css';
import t from '../../SimpleTable.module.css';

// The most recent lessons and how they were marked. Capped at 40 rows: this is
// a profile summary, not the attendance report.
const VISIBLE_ROWS = 40;

// `read`: the schedule and the attendance it is folded from have answered
// (#629). Until then the figures are the dash, not "0%", and the list says
// nothing rather than "No lessons scheduled for this student yet."
export default function AttendanceTab({ history, stats, read = true, failed = false }) {
  // The studio's date and clock, not the stored `2026-09-05` and `16:00`.
  const formatDate = useDateFormat();
  const formatTime = useTimeFormat();
  const cards = [
    { key: 'rate', value: figureOrDash(read, `${stats.rate}%`), label: 'Attendance rate' },
    { key: 'present', value: figureOrDash(read, stats.present), label: 'Present' },
    { key: 'unrecorded', value: figureOrDash(read, stats.unrecorded), label: 'Unrecorded' },
    { key: 'absent', value: figureOrDash(read, stats.absent), label: 'Absent' },
    { key: 'total', value: figureOrDash(read, stats.total), label: 'Total events' },
  ];

  return (
    <>
      <StatGrid stats={cards} className={s.statSpacing} />
      <div className={t.wrap}>
        <table className={t.table}>
          <thead><tr><th>Date</th><th>Time</th><th>Status</th><th>Billing</th></tr></thead>
          <tbody>
            {history.slice(0, VISIBLE_ROWS).map((h) => {
              const meta = coreSync().resolveAttendanceStatus(h.status);
              return (
                <tr key={h.id}>
                  <td>{formatDate(h.date) || h.date}</td>
                  <td>{h.allDay ? 'All Day' : (h.startTime ? formatTime(h.startTime) : '')}</td>
                  <td>{meta.label}</td>
                  {/* The lesson's billing, not the status table's (#362): an
                      event carrying `This event requires a make-up credit`
                      makes `Unrecorded` not billable, and unmarked future lessons
                      fill this list. `h` carries its occurrence's flag
                      (useStudentAttendance). */}
                  <td>
                    {attendanceBillingLabel(h.status, h.requiresMakeupCredit === true)}
                  </td>
                </tr>
              );
            })}
            {history.length === 0 ? (
              <tr><td colSpan={4} className={t.muted}>
                {read ? RW['student.attendanceEmpty'] : <Unread as="span" failed={failed} />}
              </td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}
